import { ALLOWED_LANGUAGES } from 'utils/language';
import { defaultMentorQuestions } from './onboarding/defaultMentorQuestions';
import { defaultCompanyFounderQuestions } from './onboarding/defaultCompanyFounderQuestions';
import { defaultFundQuestions } from './onboarding/defaultFundQuestions';
import { defaultFundFounderQuestions } from './onboarding/defaultFundFounderQuestions';
import { defaultListedCompanyQuestions } from './onboarding/defaultListedCompanyQuestions';
import { defaultRealEstateQuestions } from './onboarding/defaultRealEstateQuestions';
import { defaultCryptoQuestions } from './onboarding/defaultCryptoQuestions';
import { defaultOtherQuestions } from './onboarding/defaultOtherQuestions';
import { defaultInvestorQuestions } from './onboarding/defaultInvestorQuestions';
import { defaultCompanyQuestions } from './onboarding/defaultCompanyQuestions';

const getTranslated = (dq, literals) => ALLOWED_LANGUAGES.reduce((acc, lang) => (
  { ...acc, [lang]: literals[dq] || dq || '' }
), {});

const getSelectAnswers = (array, literals) => array.map((item, index) => {
  // eslint-disable-next-line no-nested-ternary
  const text = typeof item === 'boolean' ? (item ? 'yes' : 'no') : item;
  return {
    order: index,
    text: getTranslated(text, literals),
    id: item,
  };
});

const filterAndSortQuestions = (questions, platformQuestions = [], admin = false) => questions
  .filter(dq => platformQuestions.includes(dq.info.id.split('.')[0]) || (admin && dq.admin))
  .map(dq => {
    const auxId = dq.info.id.split('.');
    const order = platformQuestions.indexOf(auxId[0]) - platformQuestions.length;
    return { ...dq, order };
  })
  .sort((a, b) => a.order - b.order);

const createDefaultQuestions = (defaultQuestions, literals) => defaultQuestions.map((dq, index) => {
  const { admin, literals: literalsObject, ...question } = dq;
  const answerLiterals = literalsObject ? literals[literalsObject] : literals;
  return {
    id: `defaultQuestion${index + 1}`,
    type: 'question',
    default: true,
    admin: dq.admin,
    info: {
      ...question,
      placeholder: getTranslated(dq.placeholder, literals),
      title: getTranslated(dq.title, literals),
      tooltip: getTranslated(dq.tooltip, literals),
      answers: Array.isArray(dq.answers) ? getSelectAnswers(dq.answers, answerLiterals) : dq.answers,
      inputs: dq.inputs ? dq.inputs.map(input => ({ ...input, placeholder: getTranslated(input.placeholder, literals) })) : undefined,
    },
  };
});

export const createDefaultQuestionsMentor = (literals, platformQuestions) => {
  const defaultQuestions = createDefaultQuestions(defaultMentorQuestions, literals);
  return filterAndSortQuestions(defaultQuestions, platformQuestions);
};

export const createDefaultQuestionsInvestor = (literals) => {
  const defaultQuestions = createDefaultQuestions(defaultInvestorQuestions, literals);
  return defaultQuestions;
};

export const createDefaultQuestionsCompanyFounder = (literals, platformQuestions) => {
  const defaultQuestions = createDefaultQuestions(defaultCompanyFounderQuestions, literals);
  return filterAndSortQuestions(defaultQuestions, platformQuestions);
};

export const createDefaultQuestionsCompany = (literals) => {
  const defaultQuestions = createDefaultQuestions(defaultCompanyQuestions, literals);
  return defaultQuestions;
};

export const createDefaultQuestionsFund = (literals) => {
  const defaultQuestions = createDefaultQuestions(defaultFundQuestions, literals);
  return defaultQuestions;
};

export const createDefaultQuestionsFundFounder = (literals, platformQuestions) => {
  const defaultQuestions = createDefaultQuestions(defaultFundFounderQuestions, literals);
  return filterAndSortQuestions(defaultQuestions, platformQuestions);
};

export const createDefaultQuestionsListedCompany = (literals) => {
  const defaultQuestions = createDefaultQuestions(defaultListedCompanyQuestions, literals);
  return defaultQuestions;
};

export const createDefaultQuestionsRealEstate = (literals) => {
  const defaultQuestions = createDefaultQuestions(defaultRealEstateQuestions, literals);
  return defaultQuestions;
};

export const createDefaultQuestionsCrypto = (literals) => {
  const defaultQuestions = createDefaultQuestions(defaultCryptoQuestions, literals);
  return defaultQuestions;
};

export const createDefaultQuestionsOther = (literals) => {
  const defaultQuestions = createDefaultQuestions(defaultOtherQuestions, literals);
  return defaultQuestions;
};
